import React from 'react'

import { Flex, Text } from 'components/ds'

import type { BillingPeriod } from './billing-period-row'
import SubscriptionRow from './subscription-row'

type Props = {
  /** Null for periods the app doesn't support yet, which leaves out how often it's billed */
  period: BillingPeriod | null
  /** Next renewal date, already formatted */
  renewsOn: string
  /** Amount charged per billing period, already formatted in the subscription currency */
  amount: string
}

/** Amount due at the next renewal. */
const BillingSummaryRow = ({
  period,
  renewsOn,
  amount,
}: Props): React.ReactNode => {
  return (
    <SubscriptionRow
      title="Billing summary"
      subtitle={`Amount due on ${renewsOn}`}
      emphasised
      aside={
        <Flex direction="column" align="end" gap="1">
          <Text size="2" weight="bold">
            {amount}
          </Text>
          {period && (
            <Text size="1" color="gray">
              {period === 'annual' ? 'Billed annually' : 'Billed monthly'}
            </Text>
          )}
        </Flex>
      }
    />
  )
}

export default BillingSummaryRow
